export enum EvaluationResultState {
  Pending = 0,
  Approved = 1,
  Failed = 2,
}

const { Pending, Approved, Failed } = EvaluationResultState
export const getTranslationKeyEvaluationResultState = (
  modality: EvaluationResultState
) => {
  const modalities = {
    [Pending]: 'pending',
    [Approved]: 'approved',
    [Failed]: 'failed',
  }
  return modalities[modality] || modalities[Pending]
}
